import type { SavedStrategy } from "@/types/api";
import { request } from "./transport";

export interface SavedStrategyInput {
  name: string;
  ticker: string;
  layers: unknown[];
  notes?: string | null;
  tags?: string[];
  user_saved?: boolean;
}

export interface SavedStrategyLimits {
  per_ticker: number;
  total: number;
}

export const DEFAULT_SAVED_STRATEGY_LIMITS: SavedStrategyLimits = {
  per_ticker: 20,
  total: 100,
};

export const savedStrategies = {
  listSavedStrategies: (params?: { ticker?: string }) => {
    const qs = params?.ticker
      ? `?${new URLSearchParams({ ticker: params.ticker }).toString()}`
      : "";
    return request<{
      saved_strategies: SavedStrategy[];
      limits?: SavedStrategyLimits;
    }>(`/saved_strategies${qs}`);
  },

  createSavedStrategy: (input: SavedStrategyInput) =>
    request<{ saved_strategy: SavedStrategy }>("/saved_strategies", {
      method: "POST",
      body: JSON.stringify({ saved_strategy: input }),
    }),

  updateSavedStrategy: (id: string, patch: Partial<SavedStrategyInput>) =>
    request<{ saved_strategy: SavedStrategy }>(`/saved_strategies/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ saved_strategy: patch }),
    }),

  deleteSavedStrategy: (id: string) =>
    request<{ ok: true }>(`/saved_strategies/${id}`, { method: "DELETE" }),
};
